import Vue from "vue";
import { randomValue } from "@/lib/random";
import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { ADD_TRICK_TO_PERFORMANCE, REMOVE_TRICK_FROM_PERFORMANCE } = LOCAL;

export default {
	namespaced: true,
	state: {
		selectedTricks: {},
	},
	getters: {
		selected: (state) => Object.values(state.selectedTricks),
		slots: (state, getters, rootState) => rootState.global.api.data["performance-slots"],
		trickInSlot: (state) => (slot) => Object.values(state.selectedTricks).find(
			(trick) => trick.performance_slot === slot.id
		),
		trickVideoToShow: (state, getters, rootState, rootGetters) => {
			const list = rootGetters["game/scores/zeroScore"] ? rootState.global.api.data.ui.fired.performances : getters.selected;
			const tricksWithVideos = list.filter((trick) => trick.video !== false);
			const trickVideo = randomValue(tricksWithVideos);

			return { ...trickVideo?.video };
		},
		rating: (state, getters, rootState, rootGetters) => {
			const grades = rootGetters["global/api/constants"].performance_grades;
			const averagedScore = rootGetters["game/scores/averaged"];
			const averagedRating = grades.find((grade) => grade.threshold.max > averagedScore
				&& averagedScore >= grade.threshold.min);

			return averagedRating.id;
		},
	},
	actions: {
		addTrick({ commit }, trick) {
			commit(ADD_TRICK_TO_PERFORMANCE, trick);
		},
		removeTrick({ commit }, trick) {
			commit(REMOVE_TRICK_FROM_PERFORMANCE, trick);
		},
		perform({ dispatch, getters }) {
			getters.selected.forEach((trick) => {
				dispatch(`game/tricks/${trick.id}/perform`, {}, ROOT_FLAG);
			});
		},
		complete({ commit, getters }) {
			getters.selected.forEach((trick) => {
				commit(REMOVE_TRICK_FROM_PERFORMANCE, trick);
			});
		},
	},
	mutations: {
		[ADD_TRICK_TO_PERFORMANCE](state, trick) {
			Vue.set(state.selectedTricks, trick.id, trick);
		},
		[REMOVE_TRICK_FROM_PERFORMANCE](state, trick) {
			Vue.delete(state.selectedTricks, trick.id);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/performance.store.js